import React from "react";
import axios from 'axios';
import { Box, Typography, Select, MenuItem, BottomNavigation, BottomNavigationAction, Snackbar, Alert } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import globalStyles from '../../utils/globalStyles';
import uilityApi from '../../api/utility';


function ProductMasterSheet() {
  const { control } = useForm({});
  const [productStatus, setProductStatus] = React.useState('all');
  const [stockStatus, setStockStatus] = React.useState('all');
  const [exportDisble, setExportDisable] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [exportError, setExportError] = React.useState(false);
  const [channel, setChannel] = React.useState(process.env.REACT_APP_SHABABUNA_CHANNEL_ID);

  const optionArr = [
    { value: 'all', label: 'All' },
    { value: true, label: 'Enabled' },
    { value: false, label: 'Disabled' },
  ];
  const optionArr1 = [
    { value: 'all', label: 'All' },
    { value: true, label: 'In-Stok' },
    { value: false, label: 'Out-Of-Stock' },
  ];

  const optionChannel = [
    { value: process.env.REACT_APP_SHABABUNA_CHANNEL_ID, label: 'SHABABUNA' },
    { value: process.env.REACT_APP_SENSI_CHANNEL_ID, label: 'SENSI' },
  ];

  const handleErrorMsg = () => {
    setOpenAlert(true)
    setTimeout(() => {
      setOpenAlert(false)
    }, 5000)
  };
  const closeAlert = () => {
    setOpenAlert(false)
  }

  let exportPayload;
  const handleExport = () => {
    setExportDisable(true);
    setShowLoader(true);
    setExportError(false);
    setOpenAlert(false);

    exportPayload = { action: "PRODUCT_MASTER_SHEET", filter: { productStatus: productStatus, stockStatus: stockStatus, channel: channel } }

    console.log("exportPayload", exportPayload);
    axios.post(`${uilityApi.url}`, exportPayload)
      .then((res) => {
        const csvContent = res.data.map(row => {
          return row.map(cell => {
            if (cell && typeof cell === 'string' && cell.includes(',')) {
              return `"${cell}"`;
            }
            return cell ? cell.toString().trim() : '';
          }).join(',');
        }).join('\r\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const orderExportFileName = "product_master_sheet" + new Date().getTime() + ".csv";
        console.log("orderexportFile name", orderExportFileName);
        link.setAttribute('href', window.URL.createObjectURL(blob));
        link.setAttribute('download', orderExportFileName);

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setExportDisable(false);
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);
        handleErrorMsg();
        setExportDisable(false);
        console.log('Error in getting orders: ', error);
      });
  }

  return (
    <>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="error" sx={{ width: '400px', marginTop: '100px' }}>
          An error occurred while exporting
        </Alert>
      </Snackbar>
      <Box sx={globalStyles.headerWrapperBox}>
        <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
          <Typography variant='h4'>Generate Product's Master Sheet</Typography>
        </Box>
      </Box>
      <Box sx={globalStyles.headerWrapperBox}>

        <Box sx={{
          width: '100%',
          display: 'flex',
          margin: '0px 30px',
          '& .MuiInput-input': {
            width: '300px !important',
            padding: '5px 10px !important'
          },
          '& .MuiSvgIcon-root': {
            paddingRight: '10px'
          },
          justifyContent: 'space-between'
        }}>
          <Box sx={{ width: '70%', display: 'flex', justifyContent: 'space-evenly' }}>
            <Box>
              <Typography>Filter By Product Status</Typography>
              <form>
                <Controller
                  name='product-status'
                  control={control}
                  render={({ field }) =>
                    <Select
                      label="Product"
                      id="product-status"
                      value={productStatus}
                      onChange={(e) => setProductStatus(e.target.value)}
                      className={globalStyles.customSelect2}
                      sx={{ border: '1px solid #2b3f7a', width: '150px' }}
                    >
                      {optionArr.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
              </form>
            </Box>
            <Box>

              <Typography>Filter By Stock Status</Typography>
              <form>
                <Controller
                  name='stock-status'
                  control={control}
                  render={({ field }) =>
                    <Select
                      label="stock"
                      id="stock-status"
                      value={stockStatus}
                      onChange={(e) => setStockStatus(e.target.value)}
                      className={globalStyles.customSelect2}
                      sx={{ border: '1px solid #2b3f7a', width: '150px' }}
                    >
                      {optionArr1.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
              </form>
            </Box>
            <Box>

              <Typography>Filter By Channel</Typography>

              <form>
                <Controller
                  name='channel-status'
                  control={control}
                  render={({ field }) =>
                    <Select
                      label="Channel"
                      id="channel-status"
                      value={channel}
                      onChange={(e) => setChannel(e.target.value)}
                      sx={{ border: '1px solid #2b3f7a', width: '150px' }}
                    >
                      {optionChannel.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
              </form>
            </Box>

          </Box>
          <Box sx={{ width: '30%', justifyContent: "end", marginLeft: '10%' }}>
            <Box sx={{
              // width: '20vw',
              justifyContent: 'end',
              textAlign: 'end',
              '& .MuiButton-sizeSmall': {
                lineHeight: '30px !important'
              },
              '& .MuiDivider-root': {
                borderRightWidth: 'thin !important',
                borderColor: '#2b3f7a'
              }
            }}>
              <Box sx={{ width: '15%' }}>
                <Box sx={{
                  // width: '10vw',
                  justifyContent: 'end',
                  textAlign: 'end',
                  '& .MuiButton-sizeSmall': {
                    lineHeight: '30px !important'
                  },
                  '& .MuiDivider-root': {
                    borderRightWidth: 'thin !important'
                  }
                }}>
                  <BottomNavigation
                    showLabels
                    sx={globalStyles.bottomNavigationExport}>
                    <BottomNavigationAction
                      label={
                        <>
                          <Box sx={globalStyles.exportLabel}>
                            {showLoader ? (
                              <>
                                Exporting&nbsp;&nbsp;&nbsp;
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              </>
                            ) : ('Export'
                            )}
                          </Box>
                        </>

                      }
                      disabled={exportDisble}
                      onClick={handleExport}

                    />
                  </BottomNavigation>

                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={{ justifyContent: 'center' }}>
      </Box>

    </>
  )
}

export default ProductMasterSheet;